import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Helper} from '../../../../helpers/helper.service';
import {FormlyFieldConfig} from '@ngx-formly/core';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {DownloadService} from '../../../Services/download.service';
import {LanguageService} from '../../../../translation/Services/language.service';
import {Download} from '../../../Models/Download';
import {environment} from '../../../../../environments/environment';
import {FileItem, FileUploader, ParsedResponseHeaders} from 'ng2-file-upload';
import {AuthenticationService} from '../../../../shared/Services/authentication.service';
import {DownloadFile} from '../../../Models/DownloadFile';
import {DownloadFilesService} from '../../../Services/download-files.service';
import {NgForm} from '@angular/forms';
import {DealerUserService} from '../../../../dealer-system/Services/dealer-user.service';
import {DealerProfileService} from '../../../Services/dealer-profile.service';

const baseUri = environment.apiUrl;
const URL = baseUri + '/backoffice/file_manager?bupload=DownloadFiles.image&quality=75';

@Component({
  selector: 'app-manage-download',
  templateUrl: './manage-download.component.html',
  styleUrls: ['./manage-download.component.scss']
})
export class ManageDownloadComponent implements OnInit {

  public classicBox;
  public lastValue = <any>{};
  public downloadObj = <any>{};
  public downloadId: number;
  public downloadFileId: number;
  public downloadFileName: string;
  public imageFileName: string;
  public isEdit = false;
  public isFileEdit = false;
  public enableSave = true;
  public languages = [];
  public roles = [];
  public profiles = [];
  public downloadFile = new DownloadFile();
  public downloadFiles: DownloadFile[] = [];
  private target: any;
  public addFileItem = false;
  public isUploading = false;
  public isNotAdd = false;
  public imageUrl = null;
  @ViewChild('addFileForm', {static: false}) addFileForm: NgForm;

  public uploader: FileUploader = new FileUploader({
    itemAlias: 'image',
    url: URL,
    authToken: this.auth.getBearerHeader(),
  });
  @ViewChild('addFileModal', {static: false}) addFileModal = null;
  @ViewChild('deleteModal', {static: false}) deleteModal = null;
  @ViewChild('uploadEl', {static: false}) uploadElRef: ElementRef;

  constructor(
    public helper: Helper,
    private route: ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private downloadService: DownloadService,
    public dealerProfileService: DealerProfileService,
    private downloadFilesService: DownloadFilesService,
    public languageService: LanguageService,
    private userService: DealerUserService,
    private auth: AuthenticationService,
  ) {
  }

  ngOnInit() {
    this.uploader.onAfterAddingFile = (item => {
      if (this.target) {
        this.target.value = '';
      }
      item.withCredentials = false;
    });

    this.route.params.subscribe(params => {
      this.languageService.list().subscribe(response => {
        response.languages.map((value) => {
          this.languages.push({
            label: value.name,
            value: value.id
          });
        });
        this.downloadService.getUserRoles().subscribe((roles) => {
          const roleItem = roles.data;
          roleItem.map((value) => {
            this.roles.push({
              label: this.translate.instant(value.name),
              value: value.id,
              // disabled: value.name === Role.ROLE_ADMIN
            });
          });
          this.dealerProfileService.getProfiles().subscribe(res => {
            res.data.map((value) => {
              this.profiles.push({
                label: value.name,
                value: value.id
              });
            });
            new Promise((resolve, reject) => {
              if (Helper.isDefined(params['id'])) {
                this.downloadId = params['id'];
                this.isEdit = true;
                this.downloadService.getDownloadItem(this.downloadId).subscribe(resp => {
                  this.lastValue = resp;
                  this.lastValue.language = this.lastValue.language.id;
                  const lastValueProfiles = [];
                  this.lastValue.profiles.forEach(profile => {
                    lastValueProfiles.push(profile.id);
                  });
                  this.lastValue.profiles = lastValueProfiles;
                  const roleIds = [];
                  this.lastValue.roles.forEach((role) => {
                    roleIds.push(role.id);
                  });
                  this.lastValue.roles = roleIds;

                  this.downloadFiles = resp.downloadFiles;
                  resolve(resp);
                });
              } else {
                resolve(new Download());
              }
            }).then(download => {
              this.lastValue = {download: (<Download>download)};
            }).then(() => {
              this.classicBox = <FormlyFieldConfig>[
                {
                  fieldGroupClassName: 'row',
                  key: 'download',
                  fieldGroup: [
                    {
                      className: 'col-3 ',
                      type: 'input',
                      key: 'categoryName',
                      templateOptions: {
                        label: this.translate.instant('doctrine.download.category_name'),
                        required: true,
                        maxLength: environment.maxStringLength,
                      },
                      validation: {
                        messages: {
                          pattern: this.translate.instant('errors.invalid'),
                          required: this.translate.instant('errors.required'),
                          maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message',
                            {limit: field.templateOptions.maxLength})
                        },
                      },
                    },
                    {
                      className: 'col-3 ',
                      type: 'input',
                      key: 'description',
                      templateOptions: {
                        label: this.translate.instant('doctrine.download.description'),
                        maxLength: environment.maxStringLength,
                      },
                      validation: {
                        messages: {
                          pattern: this.translate.instant('errors.invalid'),
                          required: this.translate.instant('errors.required'),
                          maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message',
                            {limit: field.templateOptions.maxLength})
                        },
                      },
                    },
                    {
                      key: 'language',
                      type: 'ng-select',
                      className: 'col-3 ',
                      templateOptions: {
                        label: this.translate.instant('doctrine.download.language_name'),
                        options: this.languages,
                        required: true,
                      },
                    },
                    {
                      className: 'col-3 ',
                      type: 'ng-select',
                      key: 'roles',
                      templateOptions: {
                        multiple: true,
                        required: true,
                        label: this.translate.instant('doctrine.download.store_user_access'),
                        options: this.roles
                      },
                    },
                  ],
                },
                {
                  fieldGroupClassName: 'row',
                  key: 'download',
                  fieldGroup: [
                    {
                      key: 'status',
                      type: 'ng-select',
                      className: 'col-3',
                      defaultValue: true,
                      templateOptions: {
                        label: this.translate.instant('doctrine.download.status'),
                        required: true,
                        options: [
                          {label: Download.DOWNLOAD_ACTIVE, value: true},
                          {label: Download.DOWNLOAD_INACTIVE, value: false},
                        ],
                      },
                    },
                    {
                      key: 'profiles',
                      type: 'ng-select',
                      className: 'col-3 ',
                      templateOptions: {
                        label: this.translate.instant('doctrine.invoice_dealer.profile'),
                        options: this.profiles,
                        multiple: true,
                        required: true,
                      },
                    },
                  ],
                },
              ];
            });
          });
        });
      });
    });
  }

  enableButton(event) {
    this.enableSave = event;
  }

  submitItem(next: boolean) {
    if (next) {
      const download = JSON.parse(JSON.stringify(this.lastValue));
      delete download.download.id;
      delete download.download.downloadFiles;
      this.downloadService.manageDownload(download, this.isEdit, this.downloadId).subscribe((resp) => {
        if (!this.isEdit) {
          this.downloadObj = resp;
          this.router.navigateByUrl('back-office/download/' + this.downloadObj.id);
        } else {
          this.router.navigateByUrl('/back-office/download/overview');
        }
      });
    } else {
      this.router.navigateByUrl('/back-office/download/overview');
    }
  }

  addDownload() {
    this.isFileEdit = false;
    this.addFileForm.reset();
    if (this.imageFileName) {
      this.imageFileName = '';
    }
    this.addFileModal.show();
  }

  uploadFile(cb) {
    this.addFileItem = true;
    this.isUploading = true;
    this.uploader.uploadAll();
    this.uploader.onErrorItem = (item: FileItem, response, status: number, headers: ParsedResponseHeaders) => {
      this.isUploading = false;
      this.uploader.clearQueue();
      this.uploadElRef.nativeElement.value = '';
      const res = JSON.parse(response);
      this.helper.popMessageDialog(res.title, res.errors);
    };
    this.uploader.onSuccessItem = (item: FileItem, response: string, status: number, headers: ParsedResponseHeaders) => {
      if (response) {
        this.addFileItem = false;
        this.isNotAdd = false;
        const res = JSON.parse(response);
        this.downloadFile.image = res.id;
        this.imageFileName = res.filename;
        cb();
      }
    };
  }

  addFile() {
    const id = (this.downloadFile.id) ? JSON.parse(JSON.stringify(this.downloadFile.id)) : null;
    this.downloadFile.download = this.downloadId;
    new Promise((resolve) => {
      if (this.uploader.queue.length === 0) {
        return resolve(true);
      }
      this.uploadFile(() => {
        resolve(true);
      });
    }).then(() => {
      if (this.downloadFile.image) {
        if (this.downloadFile.image['id']) {
          this.downloadFile.image = this.downloadFile.image['id'];
        }
      }
      if (this.isFileEdit) {
        delete this.downloadFile.id;
        delete this.downloadFile.position;
      }
      this.downloadFilesService.manageDownloadFile(this.downloadFile, this.isFileEdit, id).subscribe(res => {
        this.isUploading = false;
        this.addFileModal.hide();
        this.downloadFile = new DownloadFile();
        this.uploader.clearQueue();
        this.uploadElRef.nativeElement.value = '';
        this.getDownloadFiles();
      });
    });
  }

  getDownloadFiles() {
    this.downloadService.getDownloadItem(this.downloadId).subscribe(resp => {
      this.downloadFiles = resp.downloadFiles;
    });
  }

  convertSize(size) {
    if (size < 1024) {
      return size + ' Bytes';
    } else if (size < 1048576) {
      return (size / 1024).toFixed(2) + ' KB';
    } else if (size < 1073741824) {
      return (size / 1048576).toFixed(2) + ' MB';
    }
  }

  showDeleteModal(id, fileName) {
    this.downloadFileName = fileName;
    this.downloadFileId = id;
    this.deleteModal.show();
  }

  delete() {
    this.downloadFilesService.deleteDownloadFile(this.downloadFileId).subscribe((res) => {
      this.deleteModal.hide();
      this.getDownloadFiles();
    });
  }

  showAddFileModal(file) {
    this.downloadFile = JSON.parse(JSON.stringify(file));
    this.imageFileName = file.image.filename;
    this.isFileEdit = true;
    this.addFileModal.show();
  }

  changeImage(event) {
    const element: HTMLElement = document.getElementById('uploaderFile') as HTMLElement;
    this.uploader.clearQueue();
    this.uploadElRef.nativeElement.value = '';
    this.imageFileName = '';
    element.click();
  }

  cancelUpload() {
    this.addFileModal.hide();
    this.uploader.clearQueue();
    this.uploadElRef.nativeElement.value = '';
    this.imageFileName = '';
    this.addFileForm.resetForm();
  }

  positionChange(fileId, positionNumber) {
    const position = {position: positionNumber};
    this.downloadService.setFilePosition(position, fileId).subscribe(
      (res) => {
        this.getDownloadFiles();

      }
    );
  }
}
